define('home/templates/blacklistErrorMessage',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"We are unable to post your comment because %(blocker)s has placed your account in a timeout. You will be able to comment again when your timeout expires.",{"name":"gettext","hash":{"blocker":(depth0 != null ? depth0.blocker : depth0)},"data":data}))
    + "\n";
},"3":function(container,depth0,helpers,partials,data) {
    return container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"We are unable to post your comment because you have been banned by %(blocker)s.",{"name":"gettext","hash":{"blocker":(depth0 != null ? depth0.blocker : depth0)},"data":data}))
    + "\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {};

  return ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isTemp : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "<a target=\"_blank\" href=\"https://help.disqus.com/customer/portal/articles/466223-who-deleted-or-removed-my-comment-\">"
    + container.escapeExpression(helpers.gettext.call(alias1,"Find out more.",{"name":"gettext","hash":{},"data":data}))
    + "</a>\n";
},"useData":true})

});
